<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import { Link } from "svelte-routing";
  import emailjs from "@emailjs/browser";
  
  let prevScrollPos = window.pageYOffset || document.documentElement.scrollTop;
  
  // Contact form state
  let firstName = "";
  let lastName = "";
  let company = "";
  let email = "";
  let phone = "";
  let helpOption = "";
  let message = "";
  let submitting = false;
  let submitStatus = "";

  async function handleSubmit() {
    submitting = true;
    submitStatus = "";

    const payload = {
      title: "Free Consultation Request",
      to_email: "craft2code743@gmail.com",
      name: firstName + " " + lastName,
      from_name: firstName + " " + lastName,
      email: email,
      from_email: email,
      company: company,
      phone: phone,
      help_option: helpOption,
      message: message,
    };

    try {
      const response = await emailjs.send(
        "service_3137pxo",
        "template_kxc76ui",
        payload
      );
      console.log("✅ Email sent successfully!", response.status, response.text);
      submitStatus = "success";
      firstName = ""; lastName = ""; company = ""; email = "";
      phone = ""; helpOption = ""; message = "";
    } catch (err) {
      console.error("❌ EmailJS failed to send email.", err);
      submitStatus = "error";
    }
    submitting = false;
  }

  onMount(() => {
    emailjs.init("fHRZE2qnPN5GaQpnY");
    window.addEventListener("scroll", handleScroll);
  });

  function handleScroll() {
    const currentScrollPos =
      window.pageYOffset || document.documentElement.scrollTop;
    const element = document.getElementById("footerImage");
    const rect = element.getBoundingClientRect();
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;

    // Calculate the distance scrolled since the last scroll event
    const scrollDistance = currentScrollPos - prevScrollPos;

    // Calculate the scaling factor based on the scroll direction
    const scaleIncrement = scrollDistance > 0 ? 0.01 : -0.01;

    // Adjust the scale of the image
    const currentScale =
      parseFloat(
        element.style.transform.replace("scale(", "").replace(")", "")
      ) || 1;
    const newScale = Math.max(
      0.5,
      Math.min(1.2, currentScale + scaleIncrement)
    ); // Limit the scale between 0.5 and 1.5

    // Update the scale of the image
    element.style.transform = `scale(${newScale})`;

    // Update previous scroll position
    prevScrollPos = currentScrollPos;
  }

  function navigateTo(destination) {
    goto(destination);
  }
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
  />
</svelte:head>

<div class="serv1">
  <div class="image-container">
    <img src="/img/5.jpg" alt="Background Image" />
    <div class="overlay"></div>
    <!-- Overlay layer -->
  </div>
  <div class="content1">
    <h1 class="services-heading">Services & Solutions</h1>
    <p class="services-description">
      Take your company to new heights by investing in our reliable and
      efficient technology<br /> solutions.
    </p>
  </div>
</div>
<!-- <div class="pagewrap">
  <div class="container">
    <img src="/img/service.png" alt="Background Image" class="full-width" />
  </div>
</div> -->

<div class="serv2">
  <p class="serv2-text">
    Your trusted partner for innovative development solutions. With expertise in
    software engineering,<br /> project management, and product optimization, we
    strive to enhance your business<br /> operations and drive growth.
  </p>
</div>

<div class="serv3">
  <div class="serv3-heading">
    <h2>
      Offering comprehensive development<br /> solutions customized for businesses.
    </h2>
  </div>
  <div class="leftserv">
    <p class="leftser3-text">
      Delivering truly comprehensive development services across all spheres,
      ensuring an excellent experience with our expertise and experience.
      Explore our comprehensive services below."
    </p>
  </div>
  <div class="rightserv">
    <p class="rightser3-text">
      Craft2Code ensures you have the full spectrum of development services,
      from consulting to network management. With us, you can leave your
      development worries behind and focus on your core business.
    </p>
  </div>
</div>

<div class="bb">
  <div class="card-container3">
    <div class="card3">
      <i class="fas fa-globe"></i>
      <h3>Blockchain</h3>
      <p>Revolutionize your operations with blockchain technology.</p>
      <button class="card-btn3" on:click={() => navigate("/blockchain")}
        ><span>L</span><span>e</span><span>a</span><span>r</span><span>n</span>
        <span>M</span><span>o</span><span>r</span><span>e</span></button
      >
    </div>
    <div class="card3">
      <i class="fas fa-lightbulb"></i>
      <h3>Software</h3>
      <p>Transform your ideas into robust software solutions.</p>

      <button class="card-btn3" on:click={() => navigate("/web")}
        ><span>L</span><span>e</span><span>a</span><span>r</span><span>n</span>
        <span>M</span><span>o</span><span>r</span><span>e</span></button
      >
    </div>
    <div class="card3">
      <i class="fas fa-brain"></i>
      <h3>Web</h3>
      <p>Create stunning websites that captivate your audience.</p>
      <button class="card-btn3" on:click={() => navigate("/software")}>
        <span>L</span><span>e</span><span>a</span><span>r</span><span>n</span>
        <span>M</span><span>o</span><span>r</span><span>e</span></button
      >
    </div>
  </div>

  <div class="card-container3">
    <div class="card3">
      <i class="fas fa-mobile-alt"></i>
      <h3>Mobile App</h3>
      <p>Deliver seamless experiences with intuitive mobile apps.</p>
      <button class="card-btn3" on:click={() => navigate("/mobileapp")}
        ><span>L</span><span>e</span><span>a</span><span>r</span><span>n</span>
        <span>M</span><span>o</span><span>r</span><span>e</span></button
      >
    </div>
    <div class="card3">
      <i class="fas fa-gamepad"></i>
      <h3>Game</h3>
      <p>Engage users with captivating and immersive gaming experiences.</p>
      <button class="card-btn3" on:click={() => navigate("/game")}>
        <span>L</span><span>e</span><span>a</span><span>r</span><span>n</span>
        <span>M</span><span>o</span><span>r</span><span>e</span>
      </button>
    </div>
    <div class="card3">
      <i class="fas fa-envelope"></i>
      <h3>Contact Us</h3>
      <p>Get in touch with us for personalized assistance.</p>
      <button class="card-btn3" on:click={() => navigate("/contact")}
        ><span>L</span><span>e</span><span>a</span><span>r</span><span>n</span>
        <span>M</span><span>o</span><span>r</span><span>e</span></button
      >
    </div>
  </div>
</div>

<div class="ser5">
  <div class="left5">
    <h2>Craft2Code Services</h2>
    <p>
      Craft2Code services offer businesses a competitive edge by delivering a
      host of benefits. Opting for outsourced Development services enhances
      business efficiency and fosters trust with customers and clients.
    </p>
    <button class="contact-btn" on:click={() => document.getElementById('consultation-form').scrollIntoView({ behavior: 'smooth' })}>Get in touch</button>
  </div>
  <div class="right5">
    <img src="/img/6.jpg" alt="Image Description" />
  </div>
</div>

<div class="cont">
  <div class="leftco">
    <!-- <div class="top-left-text1">Contact Us</div> -->
    <div class="bottom-left-textc">
      Partner with us <br /> for development
    </div>
    <div class="left-text">
      We’re happy to answer any questions you may have and help<br /> you determine
      which of our services best fit your needs.
    </div>
    <div class="left-text">Call us at: 76 361 951</div>
    <div class="left-text">Your benefits:</div>
    <div class="benefits-container">
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Client-oriented
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Independent
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Competent
        </div>
      </div>
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Results-driven
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Problem-solving
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Transparent
        </div>
      </div>
    </div>
    <div class="left-text">What happens next?</div>
    <div class="steps">
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We Schedule a call at<br /> your convenience
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We do a discovery <br />and consulting meting
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We prepare a<br /> proposal
      </div>
    </div>
  </div>
  <div class="rightco">
    <div class="contact-form-container" id="consultation-form">
      <h2 style="text-align: center;">Schedule a Free Consultation</h2>
      <div class="contact-form">
        <div class="form-group">
          <div class="name-inputs">
            <input
              type="text"
              id="firstName"
              name="firstName"
              placeholder="First Name"
              bind:value={firstName}
              required
            />
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Last Name"
              bind:value={lastName}
              required
            />
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            id="company"
            name="company"
            placeholder="Company/Organization"
            bind:value={company}
          />
        </div>
        <div class="form-group">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Company Email"
            bind:value={email}
            required
          />
        </div>
        <div class="form-group">
          <input type="text" id="phone" name="phone" placeholder="Phone" bind:value={phone} />
        </div>
        <div class="form-group">
          <select id="helpOption" name="helpOption" bind:value={helpOption}>
            <option value="">How can we help you?</option>
            <option value="Mobile App Development">Mobile App Development</option>
            <option value="Software Development">Software Development</option>
            <option value="Web Development">Web Development</option>
            <option value="Blockchain">Blockchain</option>
            <option value="Game Development">Game Development</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="form-group">
          <textarea id="message" name="message" rows="6" placeholder="Message" bind:value={message}
          ></textarea>
        </div>
        {#if submitStatus === "success"}
          <p class="form-success">✅ Message sent successfully! We'll be in touch soon.</p>
        {:else if submitStatus === "error"}
          <p class="form-error">❌ Something went wrong. Please try again or email us at craft2code743@gmail.com</p>
        {/if}
        <button type="button" class="submit-button" disabled={submitting} on:click={handleSubmit}>
          {submitting ? "Sending..." : "Submit"}
        </button>
      </div>
    </div>
  </div>
</div>

<footer class="footer">
  <div class="footer-content">
    <div class="leftfoo">
      <div class="footer-section">
        <div class="links-development">
          <div class="quick-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/home" style="color: black;">Home</Link></li>
              <li><Link to="/service" style="color: black;">Services</Link></li>
              <li><Link to="/about" style="color: black;">About Us</Link></li>
              <li>
                <Link to="/contact" style="color: black;">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div class="development">
            <h4>Development</h4>
            <ul>
              <li>
                <Link to="/mobileapp" style="color: black;">Mobile App</Link>
              </li>
              <li>
                <Link to="/software" style="color: black;">Web</Link>
              </li>
              <li><Link to="/game" style="color: black;">Game</Link></li>
              <li><Link to="/web" style="color: black;">Software</Link></li>
              <li>
                <Link to="/blockchain" style="color: black;">Blockchain</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="rightfo">
      <div class="image-container">
        <img src="/img/34.png" alt="Footer Image" id="footerImage" />
        <div class="text-overlay">
          <h2 style="transform: scale(0.7);"><img src="/img/logo12.png" /></h2>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="hofo">
  <div class="detail-containerfo">
    <div class="detailfo">
      <p>
        REVIEWED ON
        <span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span>
      </p>
      <p>
        <!-- <span style="color: black; font-size: 24px;">CLUTCH</span> -->
        <span style="color: gray;">31 reviews</span>
      </p>
    </div>
    <!-- <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>God Of Mining</p>
      <p>Lebanon</p>
    </div> -->
    <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>T: 76 361 951</p>
      <p>E: Info@craft2code.com</p>
    </div>
    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.linkedin.com/company/craft2code" target="_blank">
          <i class="fab fa-linkedin"></i>
        </a>
      </p>
      <p>LinkedIn</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.instagram.com/craft2code/" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
      </p>
      <p>Instagram</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.facebook.com/craft2code" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
      </p>
      <p>Facebook</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://maps.app.goo.gl/wCDPsTqkkNU39Fds6" target="_blank">
          <i class="fas fa-map-marker-alt"></i>
        </a>
      </p>
      <p>Location</p>
    </div>
  </div>
  <div class="center-textfooo">
    <p>© 2024Tecnologia Terms & Conditions Privacy Policy</p>
  </div>
</div>

<style>
  /* css for footer */
  .hofo {
    padding: 20px;
  }

  .detail-containerfo {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .detailfo {
    flex: 1;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
  }

  .vertical-linefo {
    border-left: 1px solid #ccc;
    margin: 0 10px;
  }

  .detailfo p {
    margin: 0;
    font-size: 0.8rem;
  }

  .detailfo .blue-textfo i {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .stars {
    font-size: 24px;
  }

  .blue-textfo p:first-child {
    margin: 0;
    font-size: 0.8rem;
    color: #dc1f26;
  }

  .blue-textfo p:first-child i {
    margin: 0;
    font-size: 1.2rem;
    color: #dc1f26;
  }

  .blue-textfo p:last-child {
    color: black;
  }

  .hofo {
    border-top: 1px solid #ccc;
    padding: 10px 0;
    margin-top: 20px;
  }

  .center-textfooo {
    text-align: center;
    margin-top: 20px;
  }

  .rightfo .image-containerff {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .rightfo img {
    width: 100%;
    height: 100%; /* Make the image take full height */
    object-fit: cover; /* Ensure the image covers the container */
    transition: transform 0.5s; /* Add transition effect for scaling */
  }

  .rightfo img:hover {
    transform: scale(1.1); /* Increase scale on hover */
  }
  .text-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 10;
  }

  .text-overlay h2 {
    margin-top: 20px; /* Add margin to separate the elements */
  }

  .footer {
    margin-top: 30px;
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    justify-content: space-between;
    height: auto; /* Set the footer height to full viewport height */
  }
  .footer-content {
    display: flex;
  }

  .leftfoo {
    height: 100%;
    width: 50%;
  }

  .rightfo {
    width: 50%;
    position: relative;
    display: flex;
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    text-align: center;
    height: 100%; /* Ensure it takes full height */
  }

  .leftfoo .footer-section {
    margin-bottom: 20px;
  }

  .rightfo button {
    background-color: #39e9e0;
    color: #333333;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .rightfo h2 {
    color: #333333;
    font-family: BreeSerif;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .leftfoo .footer-section h4 {
    color: #333333;
    font-size: 1.8rem;
    font-family: SourceSans;
    font-weight: bold;
    margin-top: 65px;
  }

  .leftfoo .footer-section ul {
    list-style: none;
    padding-top: 0px;
    margin-top: 0;
  }

  .leftfoo .footer-section ul li {
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .leftfoo .footer-section ul li a {
    color: #333333;
    font-family: SourceSans;
    text-decoration: none;
  }

  .leftfoo .footer-section ul li a:hover {
    color: #dc1f26;
  }

  .leftfoo .footer-section input[type="email"] {
    margin-top: 50px;
    padding: 15px;
    border: none;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-left: 20px;
    background-color: #333333;
    color: white;
    border: 2px solid white; /* Set transparent border by default */
    width: calc(100% - 200px); /* Adjusted width to account for margin */
  }

  .leftfoo .footer-section input[type="checkbox"] {
    margin-top: 15px;
    margin-left: 30px;
    margin-right: 10px;
    transform: scale(1);
  }

  .leftfoo .footer-section .checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    margin-top: 15px;
  }
  .leftfoo .footer-section label {
    padding-right: 200px;
    font-size: 0.8rem; /* Increase font size of the checkbox label */
  }

  .leftfoo .footer-section button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .leftfoo .footer-section button::before,
  .leftfoo .footer-section button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .leftfoo .footer-section button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .leftfoo .footer-section button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .leftfoo .footer-section button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .leftfoo .footer-section button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .leftfoo .footer-section button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }
  .rightfo h2 {
    z-index: 10;
  }

  .rightfo button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .rightfo button::before,
  .rightfo button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .rightfo button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .rightfo button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .rightfo button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .rightfo button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .rightfo button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .links-development {
    display: flex;
  }

  .quick-links,
  .development {
    margin-left: 30px;
    padding-top: 5px;
    flex: 1;
  }

  .quick-links ul,
  .development ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .quick-links h4,
  .development h4 {
    font-size: 1.9rem;
  }

  /* css for contact */
  .cont {
    padding-top: 30px;
    display: flex;
    /* background: linear-gradient(
      to bottom,
      white 0%,
      white 19%,
      #dc1f26 20%,
      red 70%,
      white 71%
    ); */
    /* background: linear-gradient(45deg, #ffffff, #dc1f26, #ffffff); */
    width: 100%;
  }

  .leftco {
    flex: 70%; /* Set the left div to take up 70% of the available space */
    color: #333333;
    padding-left: 120px;
  }

  .left-text {
    padding-top: 50px;
    font-size: 1.3em;
    font-family: BreeSerif;
  }

  .benefits-container {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
  }

  .benefits {
    flex: 1;
    font-family: BreeSerif;
  }

  .benefit {
    padding: 5px 0;
    font-family: SourceSans;
  }

  .benefit i {
    margin-right: 10px;
  }

  .steps {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    font-family: BreeSerif;
  }

  .step {
    padding-bottom: 20px;
    flex: 1;
    font-family: SourceSans;
  }

  .top-left-text1 {
    /* top: 20px; */
    padding-top: 0px;
    margin-top: 0px;
    font-family: SourceSans;

    font-size: 18px;
  }
  .name-inputs {
    display: flex;
  }

  .name-inputs input {
    flex: 1; /* Take up equal space */
    margin-right: 10px; /* Add space between inputs */
  }

  .name-inputs input:last-child {
    margin-right: 0; /* Remove margin from last input */
  }
  .rightco {
    background-color: white;
    /* margin-top: 10px; */
    margin-right: 200px;
    margin-bottom: 30px;
    flex: 50%; /* Set the right div to take up 30% of the available space */
  }

  .contact-form-container {
    display: flex;
    flex-direction: column; /* Align items vertically */
    align-items: center; /* Center items horizontally */
    padding-right: 20px;
  }

  .contact-form-container h2 {
    color: #333333;
    font-family: BreeSerif;
    margin-bottom: 20px;
  }

  .form-group {
    margin-bottom: 20px;
    text-align: left;
    padding-left: 10px;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .form-group select {
    appearance: none;
    -webkit-appearance: none;
  }

  .form-group textarea {
    resize: vertical;
  }

  .submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .form-success {
    color: #1a7a3a;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .form-error {
    color: #842029;
    background-color: #f8d7da;
    border: 1px solid #f5c2c7;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .submit-button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .submit-button::before,
  .submit-button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .submit-button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .submit-button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .submit-button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .submit-button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .submit-button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .bottom-left-textc {
    font-size: 60px;
    margin-top: 0px;
    font-weight: bold;
    font-family: SourceSans;
  }
  .testimonials-section {
    position: relative;
    text-align: center;

    width: 60%;
    margin-left: auto; /* Auto margin from left */
    margin-right: auto; /* Auto margin from right */
  }

  .testimonial {
    padding: 30px 0; /* Increase padding */
  }

  .quote {
    font-style: italic;
    font-size: 1.7rem; /* Increase font size */
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    font-weight: bold;
    font-family: BreeSerif;
  }
  .clients-text {
    color: #333333;
    font-family: BreeSerif;
    font-size: 60px; /* Adjust font size */
    margin-bottom: 20px;
  }

  .author {
    font-size: 1.2rem; /* Increase font size */
    font-family: SourceSans;
    color: #333333;
    margin-bottom: 20px;
    margin-top: 30px;
    text-align: left;
  }

  .arrow-buttons-container {
    margin-left: 20px; /* Add margin between buttons and text */
  }

  .additional-info1 {
    display: flex;
    justify-content: space-between; /* Align items to the edges */
    align-items: center; /* Center vertically */
    margin-top: 1px; /* Adjust as needed */
  }

  .detail1 {
    font-size: 1.2rem;
    text-align: right; /* Align text to the right */
  }
  .arrow-button {
    background: none;
    border: none;
    cursor: pointer;
    color: #054f76;
    font-size: 24px;
    margin: 0 10px; /* Add some space between buttons */
  }

  .arrow-button.left11 {
    margin-right: 20px;
  }

  .arrow-button.right11 {
    margin-left: 20px;
  }

  .additional-info2 {
    display: flex;
    align-items: center;
  }

  .ser5 {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    background-color: white;
    width: 100%;
    align-items: center;
  }

  .left5 {
    flex: 1;
    /* padding: 20px; */
    display: flex;
    flex-direction: column; /* Stack items vertically */
    align-items: center; /* Center items horizontally */
    justify-content: center; /* Center items vertically */
  }

  .right5 {
    display: flex;
    flex-direction: column; /* Display images in a column */
    width: 50%;
    padding: 20px; /* Adjust padding as needed */
    box-sizing: border-box; /* Include padding in width */
    height: 100%;
  }

  .left5 h2 {
    font-size: 60px;
    color: #333333;
    font-family: BreeSerif;
  }

  .left5 p {
    font-size: 1.2rem;
    font-family: SourceSans;
  }

  .contact-btn {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .contact-btn::before,
  .contact-btn::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .contact-btn::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .contact-btn::after {
    right: 50%;
    transform: translateX(50%);
  }

  .contact-btn:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .contact-btn:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .contact-btn:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }
  .right5 img {
    width: 100%; /* Full width */
    height: auto; /* Auto height based on aspect ratio */
    object-fit: contain; /* Ensure the image is contained within the specified height */
  }

  .bb {
    margin: 0; /* Ensure no margin */
    padding: 5px 0; /* Adjust padding as needed, no horizontal padding */
    left: 0;
    width: 100%; /* Ensure it spans the full width */
    position: relative; /* Ensure it's positioned correctly */
    /* background: linear-gradient(
      to bottom,
      white 0%,
      white 39%,
      #dc1f26 40%,
      #dc1f26 70%,
     white 71%
    ); */
    /* background: linear-gradient(45deg, #ffffff, #dc1f26, #ffffff); */
  }
  .card-container3 {
    display: flex;
    justify-content: space-around;

    border-radius: 10px; /* Adjusted border-radius */

    box-sizing: border-box; /* Include padding in width */
  }
  .card3 {
    transition: background-color 2s ease-in-out;
    width: 25%; /* Adjusted width */
    height: auto; /* Auto height based on content */
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    padding-top: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .card3 i {
    font-size: 60px;
    text-align: center;
    color: #000000;
    margin-bottom: 10px;
    text-align: center;
  }
  .card3 i:hover {
    color: #dc1f26;
  }
  .card3 h3 {
    margin-bottom: 10px;
    text-align: left;
    font-size: 1.7em;
    color: #333333;
    font-family: BreeSerif;
  }
  .card3:hover h3 {
    color: #dc1f26;
  }
  /* Animation for button */

  .card-btn3 {
    text-align: left;
    background-color: #ffffff;
    color: #dc1f26;
    padding: 8px 1px;
    bottom: 0px;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .card-btn3::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px; /* Adjust the height of the line */
    background-color: #dc1f26; /* Color of the line */
  }

  .card-btn3:hover::before {
    background-color: #dc1f26; /* Change the color of the line on hover */
  }
  .card-btn3 span {
    display: inline-block;
    transition: transform 0.3s ease;
  }
  .card-btn3:hover {
    color: #dc1f26;
  }

  .card3 p {
    font-size: 1.3rem;
    margin-bottom: 20px;
    font-family: SourceSans;
    text-align: left;
  }

  .serv3 {
    display: flex;
    flex-wrap: wrap; /* Ensure the children wrap properly */
    justify-content: space-between;
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .serv3-heading {
    width: 100%;
    text-align: center;
    font-size: 40px;
    color: #333333;
    font-family: BreeSerif;
  }

  .leftserv,
  .rightserv {
    width: calc(50% - 20px); /* Adjust as needed */
  }

  .leftserv {
    margin-right: 20px; /* Add space between left and right sections */
  }

  .leftser3-text,
  .rightser3-text {
    font-size: 1.3rem;
    font-family: SourceSans;
    line-height: 1.6;
    color: #333333;
  }

  .leftser3-text {
    color: #333333;
  }

  .rightser3-text {
    color: #333333;
    font-size: 1.3rem;
  }
  .serv2 {
    text-align: center;
    color: #333333;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .serv2-text {
    font-size: 1.3rem;
  }
  .serv1 {
    text-align: center;
    margin-bottom: 40px;
    width: 100%; /* Full width */
    position: relative;
    height: 100vh;
  }

  .image-container {
    width: 100%;
    height: 100%; /* Full height */
    overflow: hidden; /* Ensures image doesn't exceed container */
    position: relative; /* Needed for overlay positioning */
  }

  .image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent overlay */
    z-index: 1; /* Position overlay above image but below content */
  }

  .content1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40%;
    text-align: center;
    color: white;
    z-index: 2; /* Ensure content is above the overlay */
    padding: 0 20px; /* Padding for better readability */
  }

  .services-heading {
    font-size: 65px;
    font-family: BreeSerif;
  }

  .services-description {
    color: white; /* Changed to white for better contrast */
    font-size: 1.4rem;
    font-family: SourceSans;
    margin-top: 20px;
  }
  @media (max-width: 480px) {
    .serv1 {
      height: 100vh; /* Full viewport height */
    }

    .image-container {
      height: 100%; /* Full height */
    }

    .image-container img {
      width: 100%; /* Ensure the image is full width */
      height: 100%; /* Maintain height */
    }

    .overlay {
      display: block; /* Ensure the overlay is visible */
    }

    .content1 {
      position: absolute; /* Keep content absolute */
      top: 50%; /* Center vertically */
      left: 50%; /* Center horizontally */
      transform: translate(-50%, -50%); /* Center transformation */
      width: 80%; /* Adjust width for smaller screens */
      color: white; /* Keep text color white */
      padding: 0 10px; /* Adjust padding */
    }

    .services-heading {
      font-size: 2rem; /* Adjust font size */
      color: white; /* Keep text color white */
    }

    .services-description {
      font-size: 1rem; /* Adjust font size */
      color: white; /* Keep text color white */
    }
    .serv3 {
      flex-direction: column;
      align-items: center;
    }

    .leftserv,
    .rightserv {
      width: 100%;
      margin-right: 0; /* Remove right margin */
      margin-bottom: 20px; /* Add bottom margin for spacing */
    }

    .serv3-heading {
      font-size: 1.5rem; /* Adjust font size */
    }

    .leftser3-text,
    .rightser3-text {
      font-size: 1rem; /* Adjust font size */
      text-align: center; /* Center align text */
    }
    .serv3-heading h2 {
      font-size: 2rem; /* Adjust font size */
    }
    .title-container {
      font-size: 2rem; /* Adjust font size */
      margin-bottom: 15px; /* Adjust margin */
    }
    .card-container3 {
      flex-direction: column; /* Stack cards vertically */
      align-items: center; /* Center align the cards */
    }

    .card3 {
      width: 90%; /* Full width with margin */
      margin: 0px 0px; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding-top: 15px; /* Adjust padding */
    }

    .card3 i {
      font-size: 50px; /* Smaller font size */
    }

    .card3 h3 {
      font-size: 1.4rem; /* Adjust font size */
    }

    .card3 p {
      font-size: 1.1rem; /* Adjust font size */
    }

    .card-btn3 {
      font-size: 0.9rem; /* Adjust button font size */
    }
    .ser5 {
      margin-top: 0px;
      margin-bottom: 0px;
      padding-top: 0px;
      padding-bottom: 0px;
      margin-left: 0px;
      text-align: center;
      margin-right: 0px;

      flex-direction: column; /* Stack items vertically on small screens */
    }

    .left5 {
      width: 100%; /* Full width for left column */
      margin: 0; /* Reset margin */
      margin-bottom: 20px; /* Add bottom margin for spacing */
    }

    .right5 {
      width: 100%; /* Full width for right column */
      margin: 0; /* Reset margin */
      margin-top: 0px;
      margin-bottom: 0px;
    }

    .left5 h2 {
      font-size: 40px; /* Adjust font size */
    }

    .left5 p {
      font-size: 1rem; /* Adjust font size */
    }

    .contact-btn {
      padding: 12px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .right5 img {
      margin-top: 0px;
      margin-bottom: 0px;
      margin-left: 0px;
      margin-right: 0px;
      padding-top: 0px;
      padding-bottom: 0px;
      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
      height: 100%; /* Ensure image height adjusts according to width */
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }

    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 30px;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
    }

    .detail-containerfo {
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%;
      box-sizing: border-box;
    }

    .detailfo:nth-child(3) {
      width: 100%; /* Full width for the address section */
      padding: 10px 0; /* Add some padding for the address section */
    }

    .vertical-linefo {
      display: none;
    }
    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      width: 50%;
      margin-left: auto;
      margin-right: auto;
    }
    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }
  }

  /* Media query for min-width 481px and max-width 768px */
  @media (min-width: 481px) and (max-width: 768px) {
    .ser5 {
      flex-direction: column;
    }

    .right5 {
      width: 100%;
      padding: 0; /* Remove padding for better fit on small screens */
    }

    .left5 h2 {
      font-size: 2rem; /* Adjust font size for small screens */
    }

    .left5 p {
      font-size: 1rem; /* Adjust font size for small screens */
    }

    .right5 img {
      max-height: 300px; /* Adjust the max-height for small screens */
      width: 100%; /* Ensure full width */
      object-fit: cover; /* Cover to maintain aspect ratio */
    }

    .contact-btn {
      font-size: 1rem; /* Adjust button font size for small screens */
      padding: 10px 20px; /* Adjust button padding for small screens */
    }

    .serv3 {
      flex-direction: column;
      align-items: center;
    }
    .serv3-heading h2 {
      font-size: 2rem; /* Adjust font size */
    }
    .leftserv,
    .rightserv {
      width: 100%;
      margin-right: 0; /* Remove right margin */
      margin-bottom: 20px; /* Add bottom margin for spacing */
    }

    .serv3-heading {
      font-size: 2rem; /* Adjust font size */
    }

    .leftser3-text,
    .rightser3-text {
      font-size: 1.2rem; /* Adjust font size */
      text-align: center; /* Center align text */
    }
    .serv1 {
      height: 100vh; /* Full viewport height */
    }

    .image-container {
      height: 100%; /* Full height */
    }

    .content1 {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 60%; /* Adjust width */
      font-size: 1.2rem; /* Adjust font size */
    }

    .services-heading {
      font-size: 3rem; /* Adjust font size */
    }

    .services-description {
      font-size: 1.2rem; /* Adjust font size */
    }
    .card-container3 {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }

    .card3 {
      width: 45%; /* Adjust width */
      margin: 10px auto; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding: 18px; /* Adjust padding */
    }

    .card3 i {
      font-size: 60px; /* Adjust font size */
    }

    .card3 h3 {
      font-size: 1.5rem; /* Adjust font size */
    }

    .card3 p {
      font-size: 1.2rem; /* Adjust font size */
    }

    .card-btn3 {
      font-size: 1rem; /* Adjust button font size */
    }

    .title-container {
      font-size: 3rem; /* Adjust font size */
      margin-bottom: 18px; /* Adjust margin */
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }

    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }
  }

  /* Media query for min-width 769px and max-width 1025px */
  @media (min-width: 769px) and (max-width: 1025px) {
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }

    .leftfoo .footer-section h4 {
      font-size: 1.3rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.75rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 15px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
    .ser5 {
      flex-direction: column;
      padding: 0px;
    }

    .right5 {
      width: 100%;
      padding: 0; /* Adjust padding for tablet view */
      text-align: center; /* Center image on tablets */
    }

    .right5 img {
      max-height: 400px; /* Adjust max-height for tablet view */
      width: 100%;
      object-fit: cover; /* Cover to maintain aspect ratio */
    }

    .left5 {
      align-items: center; /* Center items horizontally */
      text-align: center; /* Center text on tablets */
    }

    .left5 h2 {
      font-size: 3rem; /* Adjust font size for tablets */
    }

    .left5 p {
      font-size: 1.1rem; /* Adjust font size for tablets */
    }

    .contact-btn {
      font-size: 1.1rem; /* Adjust button font size for tablets */
      padding: 12px 22px; /* Adjust button padding for tablets */
    }
    .card-container3 {
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }
    .card3 {
      width: 30%; /* Adjust width */
      margin: 15px auto; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding: 20px; /* Adjust padding */
    }

    .card3 i {
      font-size: 70px; /* Adjust font size */
    }

    .card3 h3 {
      font-size: 1.6rem; /* Adjust font size */
    }

    .card3 p {
      font-size: 1.25rem; /* Adjust font size */
    }

    .card-btn3 {
      font-size: 1.1rem; /* Adjust button font size */
    }
    .serv3 {
      flex-direction: row;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .leftserv,
    .rightserv {
      width: calc(50% - 10px); /* Adjust width */
      margin-right: 0; /* Remove right margin */
    }

    .leftserv {
      margin-right: 20px; /* Add space between left and right sections */
    }

    .serv3-heading {
      font-size: 2.5rem; /* Adjust font size */
    }

    .leftser3-text,
    .rightser3-text {
      font-size: 1.3rem; /* Adjust font size */
      text-align: left; /* Left align text */
    }
    .serv1 {
      height: 100vh; /* Full viewport height */
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .image-container {
      height: 100%; /* Full height */
    }

    .content1 {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50%; /* Adjust width */
      font-size: 1.4rem; /* Adjust font size */
    }

    .services-heading {
      font-size: 3.5rem; /* Adjust font size */
    }

    .services-description {
      font-size: 1.3rem; /* Adjust font size */
    }
  }

  /* Media query for min-width 1026px and max-width 1324px */
  @media (min-width: 1024px) and (max-width: 1324px) {
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
    .card3 {
      width: 25%; /* Adjust width */
      margin: 15px auto; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding: 20px; /* Adjust padding */
    }

    .card3 i {
      font-size: 75px; /* Adjust font size */
    }

    .card3 h3 {
      font-size: 1.65rem; /* Adjust font size */
    }

    .card3 p {
      font-size: 1.3rem; /* Adjust font size */
    }

    .card-btn3 {
      font-size: 1.1rem; /* Adjust button font size */
    }
    .serv3 {
      flex-direction: row;
    }

    .leftserv,
    .rightserv {
      width: calc(50% - 10px); /* Adjust width */
      margin-right: 0; /* Remove right margin */
    }

    .leftserv {
      margin-right: 20px; /* Add space between left and right sections */
    }

    .serv3-heading {
      font-size: 3rem; /* Adjust font size */
    }

    .leftser3-text,
    .rightser3-text {
      font-size: 1.3rem; /* Adjust font size */
      text-align: left; /* Left align text */
    }
    .serv1 {
      height: 100vh; /* Full viewport height */
    }

    .image-container {
      height: 100%; /* Full height */
    }

    .content1 {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 45%; /* Adjust width */
      font-size: 1.5rem; /* Adjust font size */
    }

    .services-heading {
      font-size: 4rem; /* Adjust font size */
    }

    .services-description {
      font-size: 1.4rem; /* Adjust font size */
    }
  }
</style>
